import { NgxCookiebotConfig } from "@halloverden/ngx-cookiebot";
import { environment } from "src/environments/environment";

export class CookiebotConfig extends NgxCookiebotConfig {
  blockingMode = "manual";
  cbId = environment.cbid;
  cdn = "com";
  culture = "it";
  framework = "angular";
  level = "strict";
  loadScript = true;
}